import React from 'react';
import { ReactComponent as DangerIcon } from '../../../assets/icons/Danger-Circle.svg';
import { DoctorInMemberResponse } from '../../../types/apiGeneratedTypes';
import { useDispatch } from 'react-redux';
import {
  changeAssignDoctorModalVisibility,
  changeAssignedDoctorId
} from '../../../store/memberSlice';

type Props = {
  doctorData: DoctorInMemberResponse | null;
};

const AssignedDoctor = ({ doctorData }: Props) => {
  const dispatch = useDispatch();
  return doctorData ? (
    <div
      className='assigned-doctor'
      onClick={() => {
        dispatch(changeAssignedDoctorId(doctorData?.user_id || null));
        dispatch(changeAssignDoctorModalVisibility(true));
      }}
    >
      <div className='doctor-avatar'>
        <img src={doctorData?.photo_url!} alt='avatar' />
      </div>
      <div className='doctor-name-wrapper'>
        <div className='doctor-name'>{`${doctorData?.first_name} ${doctorData?.last_name}`}</div>
        <span className='name-info'>Assigned Doctor</span>
      </div>
    </div>
  ) : (
    <div
      className='assign-doctor'
      onClick={() => dispatch(changeAssignDoctorModalVisibility(true))}
    >
      <DangerIcon />
      Assign the doctor to member
    </div>
  );
};

export default AssignedDoctor;
